import { render, staticRenderFns } from "./otherFee.vue?vue&type=template&id=50309f4e&scoped=true&"
import script from "./otherFee.vue?vue&type=script&lang=js&"
export * from "./otherFee.vue?vue&type=script&lang=js&"
import style0 from "./otherFee.vue?vue&type=style&index=0&id=50309f4e&lang=less&scoped=true&"
import style1 from "./otherFee.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50309f4e",
  null
  
)

export default component.exports